<div class="error-page-container">
    <div class="logo-container">
        <img class="logo-image" [ngStyle]="('design' | env).logoStyle" [src]="('design' | env).logo">
        <div *ngIf="('design' | env).logoText" class="logo-text ms-2">{{ ('design' | env).logoText }}</div>
    </div>
    <ng-container *ngIf="!loading">
        <div class="error-page-title mt-5 mb-3 px-3">{{ 'APP.NOT_FOUND.PAGE_NOT_FOUND' | translate }}</div>
        <div class="error-page-message px-3">{{ 'APP.NOT_FOUND.NO_LONGER_AVAILABLE' | translate }}</div>    
    </ng-container>
</div>